import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ISalesPerformanceResponse } from '../interfaces/sales-performence.interface';

@Injectable({
    providedIn: 'root'
})
export class SalesPerformanceService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getSalesPerformance(flightDateSearch: string, beginDate: string, endDate: string): Observable<ISalesPerformanceResponse> {
        const apiUrl = `${this.baseUrl}/dashboard/salesPerformance`;

        let params = new HttpParams()
            .set('flightDateSearch', flightDateSearch.toString())
            .set('beginDate', beginDate)
            .set('endDate', endDate);

        return this.http.get<ISalesPerformanceResponse>(apiUrl, { params });
    }
}
